import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: "/api",
  credentials: "include", // ✅ include cookies
});

export const baseQueryWithReAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  const status = result.error?.status;
  const retryStatuses = [400, 401, 403, 404, 500];

  if (typeof status === "number" && retryStatuses.includes(status)) {
    // 🔁 Try refresh token
    const refreshResult = await baseQuery(
      {
        url: "client-jwt-refresh/",
        method: "POST",
      },
      api,
      extraOptions
    );

    if (refreshResult.data) {
      // 🔁 Retry original request
      result = await baseQuery(args, api, extraOptions);
    } else {
      console.warn("Refresh token expired or invalid");

      // OPTIONAL: logout user
      api.dispatch({ type: "auth/logout" });
    }
  }

  return result;
};
